<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Setting Data</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/skpddata">Setting Data</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Setting Data</h4>
                  <p class="card-title-desc mb-0">Pengaturan Utama Data, meliputi Pengaturan Tahun, dan lain sebagainya.</p>
                </div>
              </div>

              <hr />

              <div class="border-bottom">
                <form action="" method="post" @submit.prevent="action(['tahunmulai', 'tahunsampai'])">
                  <h4>Pengaturan Tahun</h4>
                  <p class="text-muted">Atur Tahun yang dapat di inputkan pada proses input element data.</p>

                  <div class="d-inline-block" style="max-width: 28em; width: 100%">
                    <div class="row g-3 mb-3">
                      <div class="col-md">
                        <div class="form-floating">
                          <input type="text" class="form-control" id="tahunmulai" v-model="settings.tahunmulai">
                          <label for="tahunmulai">Mulai dari</label>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-floating">
                          <input type="text" class="form-control" id="tahunsampai" v-model="settings.tahunsampai">
                          <label for="tahunsampai">Sampai dengan</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mb-2">
                    <button type="submit" class="btn btn-primary">Simpan Perubahan</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  props: {
    _settingdata: Object,
  },
  data() {
    return {
      settings: {
        tahunmulai: null,
        tahunsampai: null
      }
    }
  },
  methods: {
    init() {
      console.log(this._settingdata);
      const keys = Object.keys(this.settings);
      keys.map(key => {
        if(this._settingdata && this._settingdata[key])
          this.settings[key] = this._settingdata[key];
      });
    },
    action(keys) {
      const data = {};
      for(let i in keys)
        data[keys[i]] = this.settings[keys[i]];
      
      if(Object.keys(data).length)
        this.$inertia.post('/admin/settingdata', data);
    }
  },
  watch: {
    _settingdata: {
      handle() {
        this.init();
      }, deep: true
    }
  },
  mounted() {
    this.init();
  }
}
</script>
